import styled, { css } from "styled-components";

import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const faqContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;

  .requirement {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .description {
      em {
        display: block;
      }

      .description-comment-1 {
        margin-bottom: 4px;
      }

      .description-comment-2 {
        margin-top: 8px;
      }

      .comment {
        color: ${TEXT_COLOR.black_3};
      }
    }
  }

  em {
    color: ${COLOR.point_400};
  }
`;

const faq = styled.div`
  em {
    color: ${COLOR.point_400};
  }
`;

const faqWithBold = styled.div`
  ${mobile(css`
    ${setFontStyle("Body3")}
  `)}

  em {
    color: ${COLOR.point_400};
  }
`;

const faqWithTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  em {
    color: ${COLOR.point_400};
  }

  > .content-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 12px;
    background-color: ${COLOR.grayScale_100};
    ${setFontStyle("Body4")}
    color: ${TEXT_COLOR.black_2};

    > .content-item {
      > .title {
        ${setFontStyle("SubHead4")}
        color: ${TEXT_COLOR.black_1};

        > em {
          display: inline-block;
          margin-left: 6px;
          ${setFontStyle("Body4")}
          color: ${COLOR.point_400};
        }
      }
    }
  }
  // 피그마 디자인 적용
  .custom-table-header-column {
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.012px;
    border: 0.5px solid ${COLOR.grayScale_300};
    background-color: #ddd;
    padding: 8px;
  }

  // 피그마 디자인 적용
  .custom-table-body-cell {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    border: 0.5px solid ${COLOR.grayScale_300};
    padding: 8px;
  }

  // 피그마 디자인 적용
  .custom-text-button {
    padding: 4px;

    ${mobile(css`
      margin-top: 6px;
    `)}
  }
`;

export default {
  faqContainer,
  faq,
  faqWithBold,
  faqWithTable,
};
